import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl } from '../config';

export class MushroomLayer extends BaseProduct {
  public readonly id: ProductId = 'mushrooms';
  private unsubscribeStore: (() => void) | null = null;
  private lastMode: string = '';
  private lastSpecies: string = '';

  protected onActivate(): void {
    this.refresh();
    this.unsubscribeStore = store.subscribe((s) => {
      if (!this.active) return;
      const currentMode = s.mushroomMode || 'current';
      const currentSpecies = s.mushroomSpecies || 'general_flush';
      if (currentMode !== this.lastMode || currentSpecies !== this.lastSpecies) {
        this.refresh();
      }
    });
  }

  protected onDeactivate(): void {
    if (this.unsubscribeStore) {
      this.unsubscribeStore();
      this.unsubscribeStore = null;
    }
    this.layerManager.removeLayer(this.id);
    this.lastMode = '';
    this.lastSpecies = '';
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(): void {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 0.85);
    const mode = state.mushroomMode || 'current';
    const species = state.mushroomSpecies || 'general_flush';
    this.lastMode = mode;
    this.lastSpecies = species;

    const targetProduct: ProductId = mode === 'outlook' ? 'mushrooms_outlook' : 'mushrooms_current';
    const tileUrl = getTileUrl(manifest, targetProduct, species, '', '');

    this.layerManager.updateRasterLayer(this.id, [tileUrl], opacity, undefined, 0, 6, 'nearest');
  }
}

export default MushroomLayer;
